import { render } from "./otarela.vue?vue&type=template&id=b390b3ce&scoped=true"
import script from "./otarela.vue?vue&type=script&lang=js"
export * from "./otarela.vue?vue&type=script&lang=js"

import "./otarela.vue?vue&type=style&index=0&id=b390b3ce&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b390b3ce"]])

export default __exports__